import styled from '@emotion/styled'
import { Dropzone } from './Dropzone'
import * as constants from 'view/styles/constants'

const COLOR_DROPZONE_EMPTY = '#a0a0a0'
const COLOR_DROPZONE_FULL = '#66bb9b'

export const DropzonePanel = styled(Dropzone)`
  padding: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border: 2px dashed ${constants.CORE_PRIMARY_2};
`
export const IconHolder = styled.div<{ isFull: boolean }>`
  display: flex;
  align-items: center;
  color: ${props => (props.isFull ? COLOR_DROPZONE_FULL : COLOR_DROPZONE_EMPTY)};
  width: 44px;
  min-height: 54px;
  svg {
    flex: 1 1 auto;
  }
`
export const DropzoneNarrative = styled.div<{ isFull: boolean }>`
  color: ${props => (props.isFull ? COLOR_DROPZONE_FULL : COLOR_DROPZONE_EMPTY)};
  white-space: normal;
  word-wrap: normal;
  max-width: 600px;
  font-size: 16px;
  margin: 6px;
  text-align: center;
  margin: 12px 0px;
`
